import type { ReactNode } from 'react';

import css from './styles.module.css';

interface Employment {
	title: string;
	company: string;
	brief: string;
	from: string;
	to: string;
	url?: string;
}

const employments: Employment[] = [
	{
		title: 'Senior Developer',
		company: '360Player',
		brief:
			"I've been a jack of all trades at 360Player for the past ten years, setting the foundation for our API, frontend routing and video analytics editor among many other things.",
		from: 'Jun 2016',
		to: 'Present',
		url: 'https://360player.com',
	},
	{
		title: 'Founder',
		company: 'Carbin Creative',
		brief:
			'I ran my own company developing, designing and maintaining websites, backend and other IT services for various clients and small scale companies.',
		from: 'Jul 2012',
		to: 'Dec 2016',
	},
	{
		title: 'Developer',
		company: 'Afonso',
		brief:
			'I briefly worked as a consultant for a Stockholm based web design agency, working on various fun projects.',
		from: 'Feb 2016',
		to: 'Jun 2016',
		url: 'https://afonso.se',
	},
	{
		title: 'Developer',
		company: 'Booli',
		brief:
			'I worked as a designer and frontend developer for HittaMäklare, a realtor broker. HittaMäklare is a subsidiary of Booli.',
		from: 'Jul 2013',
		to: 'Feb 2016',
		url: 'https://hittamaklare.se',
	},
	{
		title: 'Developer',
		company: 'WTMG',
		brief:
			'I worked as a on-site consultant frontend developer for a shopping club site called Campadre.',
		from: 'Aug 2012',
		to: 'Jun 2013',
		url: 'https://wtmg.se',
	},
	{
		title: 'Developer',
		company: 'Davelo',
		brief:
			'I built an interactive video player that was controlled by ActionScript and JavaScript as a bridge.',
		from: 'Apr 2010',
		to: 'Nov 2011',
	},
	{
		title: 'Knowledge Thirster',
		from: 'Early 1999',
		to: 'Present',
		company: 'https://',
		brief:
			'I built my first website in 1999 at the age of 11, and I have been hooked on programming and web design ever since.',
	},
];

export default function Career(): ReactNode {
	return (
		<main className={css.wrapper}>
			<div className={css.wrap}>
				<h2 data-scroll-reveal>Career.</h2>

				{employments.map(
					({ title, company, brief, from, to, url }: Employment, n) => (
						<article data-scroll-reveal key={n} className={css.employment}>
							<section className={css.duration}>
								<time>{from}</time>
								&mdash;
								<time>{to}</time>
							</section>
							<h3>{company}</h3>
							<section className={css.data}>
								<strong>{title}</strong>
								<p>{brief}</p>
								{url && (
									<a
										href={url}
										rel="external"
										target="_blank"
										data-cursor-magnetic>
										{url.replace('https://', '')}
										<svg
											xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24"
											fill="none"
											stroke="currentColor"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round">
											<path d="M7 7h10v10" />
											<path d="M7 17 17 7" />
										</svg>
									</a>
								)}
							</section>
						</article>
					)
				)}
			</div>
		</main>
	);
}
